export default __webpack_public_path__ + "static/media/offroad70000.b3d94473.jpg";